import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import Logo from './Logo';

const LINKS = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/industries', label: 'Industries' },
  { to: '/case-studies', label: 'Case Studies' },
  { to: '/careers', label: 'Careers' },
  { to: '/about', label: 'About' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-[background,border,backdrop-filter] duration-300 ${
        scrolled
          ? 'bg-[#FAF7F5]/85 backdrop-blur-md border-b border-[#EADDE2]'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              className={({ isActive }) =>
                `px-4 py-2 text-[14px] font-medium rounded-full transition-colors ${
                  isActive
                    ? 'text-[#1A1420] bg-[#F2E3E8]'
                    : 'text-[#4E434A] hover:text-[#1A1420]'
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/contact"
            className="group inline-flex items-center gap-1.5 bg-[#1A1420] text-white text-[14px] font-medium pl-4 pr-3 py-2.5 rounded-full hover:bg-[#3D1A2A] transition-colors"
          >
            Talk to us
            <span className="w-6 h-6 rounded-full bg-[#C4506F] flex items-center justify-center group-hover:rotate-45 transition-transform duration-300">
              <ArrowUpRight size={13} strokeWidth={2.4} />
            </span>
          </Link>
        </div>

        <button
          className="lg:hidden w-10 h-10 rounded-full border border-[#EADDE2] flex items-center justify-center text-[#1A1420]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FAF7F5] border-t border-[#EADDE2] px-6 py-4">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === '/'}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-lg text-[15px] ${
                    isActive ? 'bg-[#F2E3E8] text-[#1A1420]' : 'text-[#4E434A]'
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="mt-2 inline-flex items-center justify-between bg-[#1A1420] text-white px-4 py-3 rounded-lg"
            >
              Talk to us <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
